import {
  Box,
  Button,
  Divider,
  Grid,
  GridItem,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import * as React from 'react';

interface RequestDetails {
  organization: string;
  membership: string;
  firstName: string;
  lastName: string;
  workEmail: string;
  jobTitle: string;
  phoneNumber: string;
  department: string;
  reason: string;
  status: 'pending' | 'approved' | 'rejected';
  approvalMethod: 'organization' | 'association';
}

interface ReviewRequestModalProps {
  isOpen: boolean;
  requestDetails?: RequestDetails;
  onBack: () => void;
  onConfirm?: () => void;
  onError?: () => void;
  onClose?: () => void;
  isSubmitting?: boolean;
}

const ReviewRow: React.FC<{ label: string; value: React.ReactNode }> = ({
  label,
  value,
}) => (
  <Grid templateColumns="180px 1fr" gap="6" py="3" borderBottom="1px solid" borderColor="gray.200">
    <GridItem>
      <Text fontSize="sm" fontWeight="medium" color="gray.600">
        {label}
      </Text>
    </GridItem>
    <GridItem>
      <Text fontSize="sm" color="gray.900" fontWeight="500">
        {value}
      </Text>
    </GridItem>
  </Grid>
);

export const ReviewRequestModal: React.FC<ReviewRequestModalProps> = ({
  isOpen,
  requestDetails = {
    organization: 'Greenfield Agricultural Group',
    membership: 'Company Paid Employee Membership',
    firstName: 'Sam',
    lastName: 'Taylor',
    workEmail: 'sam@greenfieldag.com',
    jobTitle: 'Operations Manager',
    phoneNumber: '(555) 555-0100',
    department: 'Operations',
    reason:
      'I am a full-time employee in the operations department and need access to corporate benefits.',
    status: 'pending',
    approvalMethod: 'organization',
  },
  onBack,
  onConfirm,
  onError,
  onClose,
  isSubmitting,
}) => {
  if (!isOpen) return null;

  const approvalMethodText = {
    organization: 'Organization Admin',
    association: 'Association Admin',
  }[requestDetails?.approvalMethod || 'organization'];

  return (
    <Modal isOpen={isOpen} onClose={onClose ?? onBack} isCentered size="lg" closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW="600px" borderRadius="2xl">
        <ModalCloseButton />
        <ModalHeader pt="6">
          <Text fontSize="lg" fontWeight="semibold">
            Review your access request
          </Text>
          <Text fontSize="sm" color="gray.600" fontWeight="normal" mt="2">
            Confirm the information before submitting
          </Text>
        </ModalHeader>
        <ModalBody pb="6">
          <Stack spacing="0">
            <Box py="4">
              <VStack align="stretch" spacing="0">
                <ReviewRow
                  label="Organization"
                  value={requestDetails?.organization}
                />
                <ReviewRow
                  label="Membership"
                  value={requestDetails?.membership}
                />
              </VStack>
           
              <VStack align="stretch" spacing="0">
                <ReviewRow label="First Name" value={requestDetails?.firstName} />
                <ReviewRow label="Last Name" value={requestDetails?.lastName} />
                <ReviewRow label="Work Email" value={requestDetails?.workEmail} />
                <ReviewRow label="Job Title" value={requestDetails?.jobTitle} />
                <ReviewRow
                  label="Department"
                  value={requestDetails?.department || '-'}  
                />
                <ReviewRow
                  label="Primary Phone"
                  value={requestDetails?.phoneNumber || '-'}
                />
                <ReviewRow
                  label="Reason"
                  value={requestDetails?.reason}
                />
                <ReviewRow
                  label="Approval Route"
                  value={approvalMethodText}
                />
                <ReviewRow label="Membership end date" value="
Inherited from the corporate membership" />
              </VStack>

            </Box>


            <HStack spacing="3" justify="flex-end" mt="6">
              <Button variant="outline" onClick={onBack} colorScheme="blue">
                Back
              </Button>
              {onConfirm && (
                <Button colorScheme="blue" onClick={onConfirm} isLoading={isSubmitting}>
                  Submit Request
                </Button>
              )}
            </HStack>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
